import { Clock } from "lucide-react";

import { cn } from "@/client/lib/utils";

/**
 * Honest feedback for tenant-initiated config that automation rolls out on a
 * short cadence but without an acknowledgement back-loop. We deliberately don't
 * show a "pending -> propagated" badge here (only PXE has a real loop, PE-932);
 * instead we set the expectation that a change takes a few minutes to apply.
 */
export function ProvisioningNote({ className }: { className?: string }) {
  return (
    <p className={cn("text-muted-foreground flex items-center gap-1.5 text-xs", className)}>
      <Clock className="size-3.5 shrink-0" />
      Changes are applied within about 5 minutes.
    </p>
  );
}
